export const getServerHost = (service: string) => {
  return window.location.origin.replaceAll('app', service)
}

export const getAPIService = getServerHost('api')
export const getSSEService = getServerHost('sse')
export const getWebRTCServer = getServerHost('webrtc')
